export class CloudPrincipalGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccountEmail",
            "baseName": "serviceAccountEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudPrincipalGcp.attributeTypeMap;
    }
    constructor() {
    }
}
